import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="studio-display, xdr, imac"><path d="M9 17H15V20.25C15 20.6642 14.6642 21 14.25 21H9.75C9.33579 21 9 20.6642 9 20.25V17Z" fill="currentColor"/><rect x="2" y="3" width="20" height="13" rx="1.75" fill="currentColor"/></CentralIconBase>;
};

export default IconStudioDisplay1;
